import { ref, type Ref } from "vue";
import { postJson } from "../api/client";
import type { OneBotRuntimePayload } from "../api/types";
import { useToastStore } from "../stores/toast";

export type OneBotReconnectPayload = {
  code?: number;
  message?: string;
  onebot?: OneBotRuntimePayload;
  [key: string]: unknown;
};

type OneBotReconnectOptions = {
  actionResult: Ref<string>;
  error: Ref<string>;
  onSuccess?: (payload: OneBotReconnectPayload) => void | Promise<void>;
  successMessage?: string;
  errorMessage?: string;
};

export function useOneBotReconnect(options: OneBotReconnectOptions) {
  const toast = useToastStore();
  const reconnecting = ref(false);
  const successMessage = options.successMessage || "已请求 OneBot 重连";
  const errorMessage = options.errorMessage || "OneBot 重连失败";

  async function reconnectOneBot() {
    reconnecting.value = true;
    options.error.value = "";
    options.actionResult.value = "";
    try {
      const payload = await postJson<OneBotReconnectPayload>("/api/napcat/onebot/reconnect", {});
      if (payload.code !== undefined && payload.code !== 0) {
        throw new Error(payload.message || errorMessage);
      }
      options.actionResult.value = payload.message || successMessage;
      toast.push(options.actionResult.value);
      await options.onSuccess?.(payload);
    } catch (err) {
      options.error.value = err instanceof Error ? err.message : errorMessage;
      toast.push(options.error.value, "error");
    } finally {
      reconnecting.value = false;
    }
  }

  return { reconnecting, reconnectOneBot };
}
